export default __webpack_public_path__ + "static/media/video.f984b7db.svg";